import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { addCourse } from "../../../features/slices/coursesManagement";
import {
  addChapters,
  getChapters,
  deleteModal,
  statusChangedChapter,
  saveChapter,
} from "../../../features/slices/chapterManagement";
import { useSelector } from "react-redux";
import CommonPagination from "../../CommonPagination";
import { toastService } from "../../../utils/toastify";
import DeleteModal from "../../DeleteModal";
const initailValue = {
  chapterName: "",
  courseId: "",
  id: null,
  error: "",
};
const CourseContent = () => {
  const [iState, setUpdateState] = useState(initailValue);
  const [page, setPage] = useState(1);
  const { chapterName, deleteModal, id, error } = iState;
  const { state } = useLocation();
  const { chapters, loading } = useSelector((state) => state?.chapter);

  useEffect(() => {
    dispatch(getChapters({ courseId: state?._id, page }));
  }, [page]);
  useEffect(() => {
    if (state) {
      setUpdateState({ ...iState, courseId: state._id });
    } else {
      setUpdateState(initailValue);
    }
  }, [state]);
  const dispatch = useDispatch();
  const handleChapterNameChange = (e) => {
    setUpdateState({ ...iState, chapterName: e.target.value, error: "" });
  };
  const handleAddChapter = () => {
    if (chapterName?.trim()) {
      dispatch(addChapters(iState)).then((res) => {
        if (res?.payload?.code == 200) {
          setUpdateState({ ...iState, chapterName: "" });
          toastService.success("Chapters added successfully");
          dispatch(getChapters({ courseId: state?._id }));
        } else {
          toastService.error("Chapters added failed");
        }
      });
    } else {
      setUpdateState({ ...iState, error: " chapter name is required" });
    }
  };
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const showDeleteModal = (res) => {
    console.log(res);

    setUpdateState((prev) => ({
      ...prev,
      id: res,
      deleteModal: true,
    }));
  };
  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteModal: false,
    }));
  };
  const handleDelete = useCallback(() => {
    const data = {
      id,
      status: "DELETED",
    };
    dispatch(statusChangedChapter(data)).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success("Chapter deleted successfully");
        dispatch(getChapters({ courseId: state?._id }));
        hanldeClose();
      }
    });
  }, [id, dispatch]);

  const handleSave = () => {
    dispatch(saveChapter({ courseId: state?._id })).then((response) => {
      if (response.payload.code == 200) {
        toastService.success("Chapter saved successfully");
      } else {
        toastService.error("Chapter saved failed");
      }
    });
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">Add Course Content</h4>
            </div>
            <div className="CommonForm">
              <div className="form-group">
                <label>Chapter Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter chapter name"
                  value={chapterName}
                  onChange={handleChapterNameChange}
                />
              </div>
              {error && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {error}
                </p>
              )}
            </div>
            <button className="Button" onClick={handleAddChapter}>
              Add Chapter
            </button>
            <div className="TableList mt-4">
              <table className="table-hover">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Chapter Id</th>
                    <th>Chapter Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {chapters?.result?.[0]?.paginationData
                    ?.slice()
                    .reverse()
                    ?.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1}</td>
                          <td>{res?.chapter_number}</td>
                          <td>{res?.chapterName}</td>
                          <td>
                            <div className="Actions">
                              <Link
                                to="/courses/addLecture"
                                className="Edit"
                                state={res}
                              >
                                <i className="fa-regular fa-pen-to-square" />
                              </Link>
                              <a
                                className="Delete"
                                onClick={() => showDeleteModal(res?._id)}
                              >
                                <i className="fa-regular fa-trash-can" />
                              </a>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="Pagination mb-3">
              {chapters?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <>
                  <p>
                    Showing {(page - 1) * 10 + 1} to{" "}
                    {chapters?.result?.[0]?.paginationData?.length +
                      (page - 1) * 10}{" "}
                    of {chapters?.result?.[0]?.totalCount?.[0]?.count} results
                  </p>
                  <div className="PaginationRight">
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        chapters?.result?.[0]?.totalCount?.[0]?.count || 0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </>
              )}
            </div>
            {/* <button class="Button Discard">Discard</button> */}
            {/* <button className="Button" onClick={handleSave}>
              Save
            </button> */}
          </div>
        </div>
      </div>
      {deleteModal && (
        <DeleteModal
          hanldeClose={hanldeClose}
          handleDelete={handleDelete}
          statement="course content"
        />
      )}
    </>
  );
};

export default CourseContent;
